import { take, put } from 'redux-saga/effects';
import { routeActions } from 'redux-simple-router';

import { LOGIN, LOGOUT } from 'modules/auth/constants/actionTypes';

export function *redirectOnLogin() {
    while(true) {
        yield take(LOGIN.REQUEST);
        yield take(LOGIN.SUCCESS);
        yield put(routeActions.push('/visits'));
    }
}

